import React from 'react'
import {DynamicOptionsLoadingProps} from 'next/dynamic'

import {Box} from '@vio/atlas/helpers/Box'
import {Loader} from '@vio/atlas/Loader'

import ImportLoader from './ImportLoader'

const getLoadingComponent = () => (
  <Box display="flex" flex="1" alignItems="center" justifyContent="center">
    <Loader size="lg" />
  </Box>
)

const SpinnerImportLoader = (props: DynamicOptionsLoadingProps) => (
  <ImportLoader {...props} loadingComponent={getLoadingComponent()} />
)

export default SpinnerImportLoader
